import { useState, useEffect } from "react";
import { useBNDataLayer } from "@gw/bn-data-layer";
import { theme } from "@gw/theming";
import useMapCoordinates from "./useMapCoordinates";
import { getCoordinatesBounds } from "../../helpers/map";
var useMap = function () {
    var _a = useBNDataLayer(), dataLayerIsReady = _a.isReady, getFarmers = _a.getFarmers;
    var _b = useState([]), farmers = _b[0], setFarmers = _b[1];
    var _c = useState([
        [-83.35481383126, 36.9139205629],
        [-65.20539976876, 48.19468396725],
    ]), coordinatesBounds = _c[0], setCoordinatesBounds = _c[1];
    var _d = useState(null), activeFarmer = _d[0], setActiveFarmer = _d[1];
    var _e = useState(false), isMobile = _e[0], setIsMobile = _e[1];
    var _f = useState(true), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(false), hasError = _g[0], setHasError = _g[1];
    var _h = useMapCoordinates({
        farmers: farmers,
        setFarmers: setFarmers,
        isMobile: isMobile,
        coordinatesBounds: coordinatesBounds,
    }), mapRef = _h.mapRef, viewport = _h.viewport, onViewportChange = _h.onViewportChange, handleZoom = _h.handleZoom, resetMap = _h.resetMap;
    useEffect(function () {
        if (dataLayerIsReady) {
            getFarmers()
                .then(function (farmersProfiles) {
                if (farmersProfiles.length > 0) {
                    setFarmers(farmersProfiles);
                    setCoordinatesBounds(getCoordinatesBounds(farmersProfiles));
                }
                setIsLoading(false);
            })
                .catch(function () {
                setHasError(true);
                setIsLoading(false);
            });
        }
    }, [getFarmers, dataLayerIsReady]);
    useEffect(function () {
        var matchMedia = window.matchMedia("(min-width: " + theme.responsive.tablet_lg + ")");
        var handlerResponsive = function (ev) {
            setIsMobile(!ev.matches);
            if (ev.matches) {
                localStorage.removeItem("activeFarmerIndex");
            }
        };
        handlerResponsive(matchMedia);
        matchMedia.addEventListener("change", handlerResponsive);
        return function () {
            matchMedia.removeEventListener("change", handlerResponsive);
        };
    }, []);
    return {
        mapRef: mapRef,
        viewport: viewport,
        onViewportChange: onViewportChange,
        farmers: farmers,
        setFarmers: setFarmers,
        activeFarmer: activeFarmer,
        setActiveFarmer: setActiveFarmer,
        handleZoom: handleZoom,
        isMobile: isMobile,
        isLoading: isLoading,
        hasError: hasError,
        resetMap: resetMap,
    };
};
export default useMap;
//# sourceMappingURL=useMap.js.map